import { Card, Link } from '@heroui/react';

function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero-copy">
        <p className="eyebrow">Software Engineer</p>
        <h1>I build thoughtful software from interface to infrastructure.</h1>
        <p className="hero-text">
          Hi, I am Lucille Blain - an RIT software engineering graduate with experience across full-stack development, cloud platforms, desktop apps, and applied machine learning.
        </p>
        <div className="hero-actions" aria-label="Portfolio actions">
          <Link className="primary-action" href="#projects">
            View Projects
          </Link>
          <Link className="secondary-action" href="#skills">
            See Skills
          </Link>
        </div>
      </div>

      <Card className="terminal-card" aria-label="Developer profile snapshot">
        <Card.Header className="terminal-header">
          <span></span>
          <span></span>
          <span></span>
        </Card.Header>
        <Card.Content className="terminal-lines">
          <p>
            <span>$</span> focus --today
          </p>
          <p>Building full-stack and desktop products</p>
          <p>Working across React, TypeScript, Rust, and Azure</p>
          <p>Open to software engineering opportunities</p>
        </Card.Content>
      </Card>
    </section>
  );
}

export default Hero;
